import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

// Statically import the language-specific components for better SEO.
import CancellationPolicyEN from './en/CancellationPolicy';
import CancellationPolicyHE from './he/CancellationPolicy';

const CancellationPolicy = () => {
  const lang = useLanguage();

  let LanguageSpecificComponent;

  switch (lang) {
    case 'he':
      LanguageSpecificComponent = CancellationPolicyHE;
      break;
    case 'en':
    default:
      LanguageSpecificComponent = CancellationPolicyEN;
      break;
  }

  return <LanguageSpecificComponent />;
};

export default CancellationPolicy;
